export default __webpack_public_path__ + "static/media/avatar3.27ccb169.png";